import { ICommonApi } from './environment.type';

/** Эндпоинты проекта */
export const COMMON_APIS: ICommonApi = {
  graphql: '/api/hasura',
  graphql_ws: '/gws/hasura-ws',
  storage: '/api/storage/api',
  exporter: '/api/exporter',
  importer: '/api/importer',
  mail: '/api/mailing',
  logic: '/api/logic',
};

/** Переменные окружения, которые будут установлены после загрузки файла конфигурации */
export const LOADED_FROM_CONFIG_ENVS = {
  keycloak: {
    url: '',
    realm: '',
    clientId: '',
  },
  s3Bucket: '',
  sentryDsn: '',
};
